module.exports = __webpack_public_path__ + "images/live-touch-bg-cb979259766679b42efa8592fb4ac952.png";